import { authenticatedMiddleware } from '../permissions/middlewares/authenticatedMiddleware.js';
import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { context } from '@adornis/baseql/server/context.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet, NarrowedEntity } from '@adornis/baseql/utils/queryGeneration.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { ViewProfile } from '@adornis/view-manager/db/ViewProfile.js';
import type { Observable } from 'rxjs';

@Entity()
export class UserBasedViewProfile extends ViewProfile {
  static override _class = 'UserBasedViewProfile';

  constructor(doc: PartialEntityData<UserBasedViewProfile>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(type => String)
  userId: Maybe<string>;

  override remove() {
    localStorage.removeItem(this.category + this._id + '-filter');
    return super.remove();
  }
}

export const subscribeUserBasedViewProfiles = registerSubscription({
  operationName: 'subscribeUserBasedViewProfiles',
  middlewares: [authenticatedMiddleware],
  type: () => [UserBasedViewProfile],
  params: [{ type: () => String, name: 'category' }],
  resolve:
    (category: string) =>
    <SelSet extends BaseQLSelectionSet<UserBasedViewProfile>>(gqlFields: SelSet) => {
      const selector: Record<string, any> = { category };
      if (!context.serverContext) selector.$or = [{ userId: context.userID }, { userId: null }];
      return watchQuery(UserBasedViewProfile._collectionName, selector, {
        projection: gqlFields,
      }) as unknown as Observable<Array<NarrowedEntity<UserBasedViewProfile, SelSet>>>;
    },
});
